import { MARKET_DOMAIN, MOBILE_DOMAIN, CDN_DOMAIN, API_DOMAIN, FILE_DOMAIN } from '@/utils/domains'

const isProd = process.env.NODE_ENV === 'production'

const activityUrlPc = () => isProd ? MARKET_DOMAIN + 'detail.html' : CDN_DOMAIN + 'mk-portal-test/detail.html'
const activityUrlMobile = () => MOBILE_DOMAIN + (isProd ? '' : 'test/')
const activitySignInUrl = () => MOBILE_DOMAIN + (isProd ? 'index.html' : 'test/index.html')
const activitySignInUrl1 = () => MOBILE_DOMAIN + 'signin.html'
const qrCodeUrl = () => MARKET_DOMAIN + 't/'
const activeqrCodeUrl = () => MOBILE_DOMAIN + (isProd ? '' : 'test/') + '?wxShareType=active&wxShareId='
const featuredqrCodeUrl = () => MOBILE_DOMAIN + (isProd ? '' : 'test/') + '?wxShareType=topic&wxShareId='
const formqrCodeUrl = () => CDN_DOMAIN + (isProd ? 'mk-form/submit/mb.html?id=' : 'mk-form-test/submit/mb.html?id=')

const formPushUrl = (type) => isProd
  ? API_DOMAIN + 'formbuilder/' + type + '/html/page/push'
  : 'https://mk-wx.yybip.com/formbuilder/' + type + '/html/page/push'

const zjurl = () => formPushUrl('feiyu')
const txurl = () => formPushUrl('txqq')
const bdurl = () => formPushUrl('baidu')

export default {
  domainName: API_DOMAIN,
  picDomain: FILE_DOMAIN,
  domainName1: MARKET_DOMAIN,
  activityUrlPc: activityUrlPc(),
  activitySignInUrl: activitySignInUrl(),
  activityUrlMobile: activityUrlMobile(),
  qrCodeUrl: qrCodeUrl(),
  zjurl: zjurl(),
  txurl: txurl(),
  bdurl: bdurl(),
  activeqrCodeUrl: activeqrCodeUrl(),
  formqrCodeUrl: formqrCodeUrl(),
  featuredqrCodeUrl: featuredqrCodeUrl(),
  activeCategory: {
    pcUrl: (id, name) => (isProd ? MARKET_DOMAIN : CDN_DOMAIN + 'mk-portal-test/') + 'type.html?type=category&typeid=' + id + '&typename=' + encodeURI(name),
    h5Url: (id, name) => MOBILE_DOMAIN + (isProd ? '' : 'test/') + 'index.html?wxShareType=category&id=' + id + '&name=' + encodeURI(name),
    wxappUrl: (id, name) => 'pages/index/index?type=category&id=' + id + '&name=' + name
  },
  weixin: {
    miniprogram: {
      h5Url: path => MARKET_DOMAIN + 'miniprogramurl.html?miniprogrampath=' + encodeURIComponent(path)
    }
  }
}
